module.exports = __webpack_public_path__ + "static/media/onda-fondo-rosa-rojo-aon.499b5dd8.png";